import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    categoryDetails:{
        category_name: "",
        invetory_list:[],
        category_image: [],
        is_active:true
    },
    modal: false,
    categoryEdit: false,
    category: [],
    loading:false,
    edit:false,
    searchCategory:""
}

const categoryReducer = createSlice({
    name: "categoryReducer",
    initialState: initialState,
    reducers: {
        updateCategoryDetails:( state, {type, payload}) =>{
            state.categoryDetails = payload
        },
        updateModal: (state, {  type, payload }) => {
            state.modal = payload
        },
        updateCategoryEdit: (state, { type, payload }) => {
            state.categoryEdit = payload
        },
        updateLoadingCategories: (state, { type, payload }) => {
            state.loading = payload
        },
        updateCategories: (state, { type, payload }) => {
            state.category = payload
        },
        updateEdit: (state, { payload }) => {
            state.edit = payload
        },
        updateSearchCategory: (state, { type, payload }) => {
            state.searchCategory = payload
        },
    }
})

export const { updateCategoryDetails,updateModal, updateCategoryEdit,updateLoadingCategories, updateCategories, updateEdit, updateSearchCategory } = categoryReducer.actions

export default categoryReducer.reducer;